import React, { useState } from "react";
import "../../assets/styles/home.scss";
import Mascaras from "../../utils/masks";
import { Card } from "react-bootstrap";
import orcamentoService from "../../services/OrcamentosService";
import { ToastSuccess, ToastError } from "../../components/Toast/Toast";
export default function FormOrcamento() {
  const [nome, setNome] = useState();
  const [email, setEmail] = useState();
  const [telefone, setTelefone] = useState();
  const [empresa, setEmpresa] = useState();
  const [locacao, setLocacao] = useState();

  function resetInput() {
    setTimeout(() => {
      setNome("");
      setEmail("");
      setTelefone("");
      setEmpresa("");
      setLocacao("");
    }, 2000);
  }
  async function cadastrarOrcamento(e) {
    e.preventDefault();
    let data = {
      nome: nome,
      email: email,
      telefone: telefone,
      empresa: empresa,
      locacao: locacao,
    };
    orcamentoService
      .salvarOrcamento(data)
      .then((response) => {
        console.log(response.data);
        ToastSuccess(response.data.message);
        resetInput();
      })
      .catch((error) => {
        const errors = error.response.data.data;
        Object.keys(errors).forEach((field) => {
          const erro = field.toUpperCase() + " " + errors[field];
          ToastError(erro);
        });
      });
  }
  return (
    <Card className="card-shadow rounded">
      <Card.Header className="card-header">
        <h2 className="text-center text-white">Faça um Orçamento </h2>
      </Card.Header>
      <Card.Body>
        <div className="form">
          <p className="text-form">
            Peça seu orçamento e em instantes retornamos!
          </p>
          <form method="POST" action="">
            <label htmlFor="nome">Nome</label>
            <input
              type="text"
              name="nome"
              id="nome"
              required
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
            <label htmlFor="empresa">E-mail</label>
            <input
              type="email"
              name="email"
              id="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="telefone">Telefone</label>
            <input
              type="text"
              name="telefone"
              id="telefone"
              required
              value={telefone}
              onChange={(e) => setTelefone(Mascaras.maskPhone(e.target.value))}
            />
            <label htmlFor="empresa">Empresa</label>
            <input
              type="text"
              name="empresa"
              id="empresa"
              required
              value={empresa}
              onChange={(e) => setEmpresa(e.target.value)}
            />
            <label htmlFor="locacao">O que você quer locar?</label>
            <textarea
              name="locacao"
              id="locacao"
              cols="30"
              rows="8"
              required
              value={locacao}
              onChange={(e) => setLocacao(e.target.value)}
            ></textarea>
            <span className="message">Campo deve ter no mínimo 20 caracteres</span>
          </form>
        </div>
        <div className="d-flex justify-content-end  align-items-center">
          <button className="btn-send" onClick={cadastrarOrcamento}>
            Enviar
          </button>
        </div>
      </Card.Body>
    </Card>
  );
}
